module.exports = __webpack_public_path__ + "media/images/icon_check-a742c3aa37055144214a1a6e5cf8bfdb.svg";